import big from 'big.js';

export function getPricesWithoutVAT(priceWithoutVAT: number) {
    return {
        priceWithoutVAT: Number(big(priceWithoutVAT).toPrecision(3, big.roundUp)),
        priceWithVAT: Number(big(priceWithoutVAT).times(1.2).toPrecision(3, big.roundUp)),
    }
}

export function getPricesWithVAT(priceWithVAT: number) {
    return {
        priceWithoutVAT: Number(big(priceWithVAT).div(1.2).toPrecision(3, big.roundUp)),
        priceWithVAT: Number(big(priceWithVAT).toPrecision(3, big.roundUp)),
    }
}